import { render } from "./OriginCard.vue?vue&type=template&id=7c536fa6&scoped=true"
import script from "./OriginCard.vue?vue&type=script&lang=js"
export * from "./OriginCard.vue?vue&type=script&lang=js"

import "./OriginCard.vue?vue&type=style&index=0&id=7c536fa6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c536fa6"]])

export default __exports__